export default {
  zh: {
    steel: "钢铁",
    bronze: "青铜",
    silver: "白银",
    gold: "黄金",
    family1: "钢铁家族",
    family2: "青铜家族",
    family3: "白银家族",
    family4: "黄金家族",
    myF: "我的家族",
    levelTitle: "等级特权",
    rule: "规则",
    x: "还需{}经验,即可升级到{}家族等级",
    x1: "经验值达到{}即可升级",
    date: ((txt) => {
      return `有效期至:${txt}`
    }),
    levelExceed: "你的家族已经高于该等级",
    nextLevel: ((t) => {
      return `距离下一次等级，还需要${t}`
    }),
    needLevel: ((t) => {
      return `经验值达到${t}即可升级`
    }),
    tips:"The new event is in the pipeline and is expected to be launched in August.",
    ruleTxt: `
    1.送出礼物，获得相应金币值的经验，每上麦1分钟增加1经验值，每天上限为300经验<br/>
    2.经验值在每个月的0点清0<br/>
    3.家族达到升级条件时，会立即升级，等级有效期<br/>
    保留到下个月底，否则将降低一个等级<br/>
    4.保级：当家族在本月达到保留等级的经验值要求时，即使<br/>
    本月未达到升级要求，则他的经验值也会继续保留，一直到<br/>
    下个月底。如果未达到保留经验值，则在下个月初，自动降为下一个等级。<br/>
    5.用户退出家族以后，他在家族排行榜中的数据将会清除，但不会影响整个家族的经验值<br/>
    `
  },
  en: {
    steel: "Steel",
    bronze: "Bronze",
    silver: "Silver",
    gold: "Golden",
    family1: "Steel Family",
    family2: "Bronze Family",
    family3: "Silver Family",
    family4: "Golden Family",
    myF: "My Family",
    levelTitle: "Level Privilege",
    rule: "Rules",
    date: ((txt) => {
      return `Period of Validity: ${txt}`
    }),
    levelExceed: "Your family is above this level",
    nextLevel: ((t) => {
      return `The next level requires ${t} experience`
    }),
    needLevel: ((t) => {
      return `Upgrade when experience value reaches ${t}`
    }),
    tips:"The new event is in the pipeline and is expected to be launched in August.",
    ruleTxt: `
    1. Give gifts and get experience of corresponding gold coins. Increase experience value by 1 experience point every minute of wheat. The maximum daily experience is 300 experience points<br/>
    2. The experience value is cleared at 0 every month<br/>
    3. When the family meets the upgrade conditions, it will be upgraded immediately, and the validity period of the level will remain until the end of the next month, otherwise it will be reduced by one level<br/>
    4. Protection: When the family meets the experience value requirements of the reserved level this month, even if it does not meet the upgrade requirements this month, its experience value will continue to be retained until the end of the next month.<br/>
    If the reserved experience value is not reached, it will be automatically reduced to the next level at the beginning of the next month.<br/>
    5. After the user exits the family, his data in the family ranking list will be cleared, but the experience value of the whole family will not be affected<br/>
    `
  },
  ar: {
    steel: "الحديد",
    bronze: "البرونز",
    silver: "الفضة",
    gold: "الذهب",
    family1: "القبيلة الحديدية",
    family2: "القبيلة البرونزية",
    family3: "القبيلة الفضية",
    family4: "القبيلة الذهبية",
    myF: "المستوى الحالي",
    levelTitle: "امتياز المستوى",
    rule: "القواعد",
    date: ((txt) => {
      return `${txt} :  صالح حتى `
    }),
    levelExceed: "عائلتك فوق هذا المستوى",
    nextLevel: ((t) => {
      return `بعد المستوى التالي ، تحتاج أيضا إلى ${t}`
    }),
    needLevel: ((t) => {
      return `المستوى التالي يتطلب ${t}`
    }),
    tips:"الحدث الجديد في طور الإعداد ومن المتوقع إطلاقه في أغسطس.",
    ruleTxt: `
    1. زيادة قيمة الخبرة: إرسال الهدايا   1كوينز =1خبرة /  1دقيقة علي مايك =1 نقطة، والحد اليومي هو 300 نقطة <br/>
    2. يتم مسح قيمة الخبرة في الساعة 0:00 في اليوم الاول من كل شهر <br/>
    3.قواعد الترقية: عندما تستوفي القبيلة شروط الترقية ، سيتم ترقيتها على الفور ، ويضل المستوي  سارا حتى نهاية الشهر المقبل ، وإلا فسيتم تخفيضها بمستوي واحد <br/>
    4. الاستيفاء: عند وصول  القبيلة لمتطلبات قيمة الخبرة للاحتفاظ بمستوى هذا الشهر حتى لو  لم يتم استيفاء متطلبات الترقية هذا الشهر ، فسيتم أيضًا الاحتفاظ بنقاط خبرته حتى نهاية الشهر المقبل. إذا لم يتم الوصول إلى قيمة التجربة المحجوزة ، فسيتم تخفيضها تلقائيًا إلى المستوى السابق في بداية الشهر المقبل. <br/>
    5. بعد خروج المستخدم من القبيلة ، سيتم مسح بياناته من ترتيب اعضاء  العشيرة ، ولكنها لن تأثر على قيمة الخبرة للقبيلة		
    `
  },
  tr: {
    steel: "Steel",
    bronze: "Bronze",
    silver: "Silver",
    gold: "Golden",
    family1: "Steel Family",
    family2: "Bronze Family",
    family3: "Silver Family",
    family4: "Golden Family",
    myF: "My Family",
    levelTitle: "Level Privilege",
    rule: "Kurallar",
    tips:"Yeni Seviye Sistemi Tasarım Aşamasında ve Ağustos Ayında Başlatılacaktır.",
    date: ((txt) => {
      return `Period of Validity: ${txt}`
    }),
    levelExceed: "Your family is above this level",
    nextLevel: ((t) => {
      return `Next Level: ${t}`
    }),
    needLevel: ((t) => {
      return `Upgrade when experience value reaches ${t}`
    }),
    ruleTxt: `
    
    `
  },
  pt:{
      steel: "Aço",
    bronze: "Bronze",
    silver: "Prata",
    gold: "Ouro",
    family1: "Família Aço",
    family2: "Família Bronze",
    family3: "Família Prata",
    family4: "Família Ouro",
    myF: "Minha Família",
    levelTitle: "Privilégio de Nível",
    rule: "Regras",
    date: ((txt) => {
      return `Período de Validade: ${txt}`
    }),
    levelExceed: "Sua família está acima deste nível",
    nextLevel: ((t) => {
      return `O próximo nível exige ${t} de experiência`
    }),
    needLevel: ((t) => {
      return `Atualize quando o valor de experiência atingir ${t}`
    }),
    tips: "O novo evento está em andamento e deve ser lançado em agosto.",
    ruleTxt: `
    1. Dê presentes e obtenha experiência correspondente a moedas de ouro. Aumente o valor da experiência em 1 ponto de experiência a cada minuto de trigo. A experiência diária máxima é de 300 pontos de experiência<br/>
    2. O valor da experiência é zerado no dia 0 de cada mês<br/>
    3. Quando a família atingir as condições de upgrade, ela será atualizada imediatamente, e o período de validade do nível será mantido até o final do próximo mês, caso contrário, será reduzido em um nível<br/>
    4. Proteção: Quando a família atingir os requisitos de valor de experiência do nível reservado neste mês, mesmo que não atinja os requisitos de upgrade neste mês, o valor da experiência será mantido até o final do próximo mês.<br/>
    Se o valor da experiência reservado não for atingido, ele será automaticamente reduzido para o próximo nível no início do próximo mês.<br/>
    5. Depois que o usuário sair da família, seus dados na lista de classificação da família serão limpos, mas o valor de experiência de toda a família não será afetado<br/>
    `
  },
  id:{
        steel: "Baja",
    bronze: "Perunggu",
    silver: "Perak",
    gold: "Emas",
    family1: "Keluarga Baja",
    family2: "Keluarga Perunggu",
    family3: "Keluarga Perak",
    family4: "Keluarga Emas",
    myF: "Keluargaku",
    levelTitle: "Hak Istimewa Level",
    rule: "Aturan",
    date: ((txt) => {
      return `Periode Keberlakuan: ${txt}`
    }),
    levelExceed: "Keluargamu berada di atas level ini",
    nextLevel: ((t) => {
      return `Level berikutnya membutuhkan ${t} pengalaman`
    }),
    needLevel: ((t) => {
      return `Perbarui ketika nilai pengalaman mencapai ${t}`
    }),
    tips: "Acara baru sedang diproses dan diharapkan akan diluncurkan pada bulan Agustus.",
    ruleTxt: `
    1. Berikan hadiah dan dapatkan pengalaman dari koin emas yang sesuai. Tingkatkan nilai pengalaman sebesar 1 poin pengalaman setiap menit gandum. Pengalaman harian maksimal adalah 300 poin pengalaman<br/>
    2. Nilai pengalaman akan dihapus pada tanggal 0 setiap bulan<br/>
    3. Ketika keluarga memenuhi kondisi upgrade, level akan langsung diperbarui, dan periode keberlakuan level akan tetap sampai akhir bulan berikutnya, jika tidak, akan turun satu level<br/>
    4. Perlindungan: Ketika keluarga memenuhi persyaratan nilai pengalaman untuk level yang disimpan bulan ini, meskipun tidak memenuhi persyaratan upgrade bulan ini, nilai pengalaman tetap akan dipertahankan hingga akhir bulan berikutnya.<br/>
    Jika nilai pengalaman yang disimpan tidak tercapai, itu akan otomatis turun ke level berikutnya pada awal bulan berikutnya.<br/>
    5. Setelah pengguna keluar dari keluarga, data mereka dalam daftar peringkat keluarga akan dibersihkan, tetapi nilai pengalaman seluruh keluarga tidak akan terpengaruh<br/>
    `
  },
  uz:{
        steel: "Po'lat",
    bronze: "Bronza",
    silver: "Kumush",
    gold: "Oltin",
    family1: "Po'lat Oilasi",
    family2: "Bronza Oilasi",
    family3: "Kumush Oilasi",
    family4: "Oltin Oilasi",
    myF: "Mening Oilam",
    levelTitle: "Daraja Imtiyozi",
    rule: "Qoidalar",
    date: ((txt) => {
      return `Amal qilish muddati: ${txt}`
    }),
    levelExceed: "Sizning oilangiz bu darajadan yuqorida",
    nextLevel: ((t) => {
      return `Keyingi daraja uchun ${t} tajriba kerak`
    }),
    needLevel: ((t) => {
      return `Tajriba qiymati ${t} ga yetganda yangilanish`
    }),
    tips: "Yangi tadbir rejalashtirilmoqda va avgust oyida ishga tushirilishi kutilmoqda.",
    ruleTxt: `
    1. Sovg'alar berib, tegishli oltin tanga tajribasini oling. Har bir bug'doy daqiqasida tajriba qiymatini 1 tajriba balliga oshiring. Maksimal kundalik tajriba 300 tajriba balli<br/>
    2. Tajriba qiymati har oy 0 ga tozalanadi<br/>
    3. Oilaning yangilanish shartlarini bajarishi bilan daraja darhol yangilanadi va darajaning amal qilish muddati keyingi oy oxirigacha davom etadi, aks holda bir darajaga pasayadi<br/>
    4. Himoya: Agar oila ushbu oy uchun saqlangan daraja tajriba qiymati talablariga javob bersa, hatto agar ushbu oy yangilanish shartlariga javob bermasa ham, uning tajriba qiymati keyingi oy oxirigacha saqlanadi.<br/>
    Agar saqlangan tajriba qiymati yetmasa, keyingi oy boshida avtomatik ravishda bir darajaga pasayadi.<br/>
    5. Foydalanuvchi oiladan chiqqanidan so'ng, uning oiladagi reyting ro'yxatidagi ma'lumotlari o'chiriladi, lekin butun oilaning tajriba qiymati ta'sir qilmaydi<br/>
    `

  },

  ru:{
        steel: "Сталь",
    bronze: "Бронза",
    silver: "Серебро",
    gold: "Золото",
    family1: "Семья Стали",
    family2: "Семья Бронзы",
    family3: "Семья Серебра",
    family4: "Семья Золота",
    myF: "Моя Семья",
    levelTitle: "Привилегии уровня",
    rule: "Правила",
    date: ((txt) => {
      return `Период действия: ${txt}`
    }),
    levelExceed: "Ваша семья выше этого уровня",
    nextLevel: ((t) => {
      return `Для следующего уровня требуется ${t} опыта`
    }),
    needLevel: ((t) => {
      return `Обновление, когда значение опыта достигнет ${t}`
    }),
    tips: "Новое событие в разработке, запуск ожидается в августе.",
    ruleTxt: `
    1. Дарите подарки и получайте опыт, соответствующий золотым монетам. Увеличивайте значение опыта на 1 балл опыта каждую минуту пшеницы. Максимальное количество опыта в день — 300 баллов<br/>
    2. Значение опыта сбрасывается до 0 каждый месяц<br/>
    3. Когда семья выполняет условия для обновления, она будет немедленно обновлена, а срок действия уровня останется до конца следующего месяца, в противном случае уровень будет снижен на один<br/>
    4. Защита: Когда семья выполняет требования по значению опыта для зарезервированного уровня в этом месяце, даже если она не выполняет требования для обновления в этом месяце, ее значение опыта будет сохраняться до конца следующего месяца.<br/>
    Если зарезервированное значение опыта не достигнуто, оно автоматически будет снижено до следующего уровня в начале следующего месяца.<br/>
    5. После выхода пользователя из семьи его данные в списке рейтинга семьи будут очищены, но значение опыта всей семьи не изменится<br/>
    `

  },
  fa:{
        steel: "فولاد",
    bronze: "برنز",
    silver: "نقره",
    gold: "طلایی",
    family1: "خانواده فولاد",
    family2: "خانواده برنز",
    family3: "خانواده نقره",
    family4: "خانواده طلایی",
    myF: "خانواده من",
    levelTitle: "امتیازات سطح",
    rule: "قوانین",
    date: ((txt) => {
      return `مدت زمان اعتبار: ${txt}`
    }),
    levelExceed: "خانواده شما بالاتر از این سطح است",
    nextLevel: ((t) => {
      return `سطح بعدی نیاز به ${t} تجربه دارد`
    }),
    needLevel: ((t) => {
      return `برای ارتقاء وقتی که مقدار تجربه به ${t} رسید`
    }),
    tips: "رویداد جدید در حال آماده‌سازی است و انتظار می‌رود در ماه اوت راه‌اندازی شود.",
    ruleTxt: `
    1. هدایا بدهید و تجربه مربوط به سکه‌های طلا دریافت کنید. هر دقیقه گندم یک امتیاز تجربه اضافه می‌کند. حداکثر تجربه روزانه 300 امتیاز تجربه است<br/>
    2. مقدار تجربه هر ماه به صفر تنظیم می‌شود<br/>
    3. وقتی خانواده شرایط ارتقاء را برآورده می‌کند، بلافاصله ارتقاء می‌یابد و مدت اعتبار سطح تا پایان ماه بعد باقی می‌ماند، در غیر این صورت یک سطح کاهش می‌یابد<br/>
    4. حفاظت: وقتی خانواده شرایط مقدار تجربه برای سطح رزرو شده در این ماه را برآورده می‌کند، حتی اگر شرایط ارتقاء این ماه را نداشته باشد، مقدار تجربه آن تا پایان ماه بعد حفظ خواهد شد.<br/>
    اگر مقدار تجربه رزرو شده به دست نیاید، در ابتدای ماه بعد به سطح بعدی کاهش خواهد یافت.<br/>
    5. پس از خروج کاربر از خانواده، داده‌های او در فهرست رتبه‌بندی خانواده پاک خواهد شد، اما مقدار تجربه کل خانواده تحت تأثیر قرار نخواهد گرفت<br/>
    `

  }
}


// WEBPACK FOOTER //
// src/pages/activity/familyLevel/lang.js